<template>
  <el-dialog
    :title="openType === 'add' ? '新增价格' : '编辑价格'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    destroy-on-close
    custom-class="customModal"
    width="40%">
    <el-form ref="form" :model="formValue" :rules="rules">
        <el-form-item label="名称" prop="name" class="formItemFill">
            <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
        </el-form-item>
      <el-row>
          <el-col :span="11">
              <el-form-item label="最小价格" prop="min_price" class="formItemFill price" style="border-right: 0">
                <el-input type="number" v-model="formValue.min_price" size="small" autocomplete="off"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="2">
              <el-form-item class="formItemFill Division">
                ~~~~
              </el-form-item>
          </el-col>
          <el-col :span="11">
              <el-form-item label="最大价格" prop="max_price" class="formItemFill price" style="border-left: 0">
                <el-input type="number" v-model="formValue.max_price" size="small" autocomplete="off"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="顺序" prop="is_sort" class="formItemFill" >
                <el-input type="number" v-model="formValue.sort" size="small" autocomplete="off"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="12">
               <el-form-item label="是否启用" prop="is_enable" class="formItemFill" >
                    <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
                    <el-radio-button :label="true">是</el-radio-button>
                    <el-radio-button :label="false">否</el-radio-button>
                    </el-radio-group>
                </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">确 定</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
  export default {
    name: 'formPrice',
    data() {
      var validatePrice = (rule, value, callback) => {
          if(value === '') {
              callback(new Error('请输入最小价格'))
          }else if(value > this.formValue.max_price) {
              callback(new Error('最小价格不能超过最大价格'))
          }
          else{ callback()}
      }
      var validatePrice2 = (rule, value, callback) => {
          if(value === '') {
              callback(new Error('请输入最大价格'))
          }else if(value < this.formValue.min_price) {
              callback(new Error('最大价格不能小于最小价格'))
          }
          else{ callback()}
      }
      return {
        treeData: [],
        visible: false,
        openType: '',
        formValue: { },
        rules: {
          min_price: [
              { required: true, message: '最小价格不能为空', trigger: 'blur'},
              { validator: validatePrice, trigger: 'blur'}
          ],
          max_price: [
              { required: true, message: '最大价格不能为空', trigger: 'blur'},
              { validator: validatePrice2, trigger: 'blur'}
            ],
          sort: [{ required: true, message: '顺序不能为空'}]
        }
      }
    },
    methods: {
      async open(type, data) {
        if (type === 'add') {
          this.reset();
        } 
        else if (type === 'edit') {
          const dataDetail = await WebsiteService.getPriceDetail(data.id)
          const result = JSON.parse(JSON.stringify(dataDetail));
          this.formValue = result;
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: true,
          sort: 50
        };
      },
      async submit() {
        const result = await this.$refs.form.validate();
        if (result) {
          this.formValue.is_enable = this.formValue.is_enable === true ? 1 : 0
          await WebsiteService.saveScreening_price(this.formValue);
          this.$emit('submitSuccess')
          this.close();
        }
      },
      close() {
        this.visible = false;
        this.formValue = {};
      }
    }
  }
</script>

<style lang="scss">
    .priceScreening{
        .formItemFill.Division{
            border-left: 0;
            border-right: 0;      
            .el-form-item__content{
                line-height: 5vw;
            }      
        }
    }
</style>